import { IComponentContainerDefinition } from '@faire/web-api--source/indigofair/data/IComponentContainerDefinition';

export namespace IComponentLoggingData {
  /**
   * Return an instance of IComponentLoggingData with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IComponentLoggingData>
  ): IComponentLoggingData =>
    ({
      ...(partial ?? {}),
    }) as IComponentLoggingData;
}

export interface IComponentLoggingData {
  /**
   * Deprecated: use componentContainerDefinition instead.
   * @deprecated
   */
  component_type: string | undefined;
  /**
   * Include information like pathIdentifier to distinguish among different components with the same ComponentType.
   * Deprecated: use componentContainerDefinition instead.
   * @deprecated
   */
  component_name: string | undefined;
  component_position: number | undefined;
  component_instance_identifier: string | undefined;
  /**
   * Optionally return to have clients provide this requestId instead of the one provided in [ViewLoggingData]
   * Intended for use when components are provided outside of the initial ViewLayout response,
   * for example, for pages fetched by [FilterablePaginatedSection]
   * @protobufOption (faire.common.diffIgnore) = ALWAYS
   */
  request_id: string | undefined;
  component_container_definition: IComponentContainerDefinition | undefined;
}
